import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Terms from "./components/Terms";
import splashImage from "./assets/splash.png";
import Admin from "./components/pages/Admin";
import Managers from "./components/pages/Managers";
import Analytics from "./components/pages/Analytics";
import AnalyticsUsers from "./components/pages/AnalyticsUsers";
import AnalyticsReferrals from "./components/pages/AnalyticsReferrals";
import AdminUserProfile from "./components/pages/AdminUserProfile";
import Account from "./components/Account";
import Breadcrumbs from "./components/Breadcrumbs";
import { UserContext } from "./components/context/user/UserContext";
import { useContext, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "./styles/globals.css";
import { Routes, Route } from "react-router-dom";
import Posts from "./components/Posts";
import UsersList from "./components/UsersList";
import Reports from "./components/Reports";
import ReportedUsers from "./components/ReportedUsers";
import DeleteAccount from "./components/DeleteAccount";
import AboutUs from "./components/Aboutus";
import AddSighting from "./components/pages/AddSighting";
import PostDetail from "./components/pages/PostDetail";
import LoadingScreen from "./components/LoadingScreen";
import ToastContainer from "./components/ToastContainer";

function App() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { userData, isLoading } = useContext(UserContext);
  const isAdmin = userData?.user?.isAdmin;

  useEffect(() => {
    const publicPath = [
      "/terms",
      "/",
      "/signup",
      "/login",
      "/delete",
      "/about",
      "/aboutus",
      "/privacy",
    ].includes(pathname);
    if (!isLoading && !userData && !publicPath) {
      navigate("/login", { replace: true });
    }
  }, [userData, isLoading, pathname, navigate]);

  const adminPage = (page) =>
    isLoading ? (
      <LoadingScreen />
    ) : isAdmin ? (
      page
    ) : (
      <Navigate to="/login" replace />
    );

  const userPage = (page) =>
    isLoading ? (
      <LoadingScreen />
    ) : userData ? (
      page
    ) : (
      <Navigate to="/login" replace />
    );

  return (
    <>
      <Navbar />
      <Breadcrumbs />
      <ToastContainer />

      <Routes>
        <Route
          path="/"
          element={
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <img
                src={splashImage}
                alt="Rig Rest'r - America's Favorite Trucking App"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </div>
          }
        />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Terms />} />
        <Route path="/privacy" element={<Terms />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/admin" element={adminPage(<Admin />)} />
        <Route path="/managers" element={adminPage(<Managers />)} />
        <Route path="/analytics" element={adminPage(<Analytics />)} />
        <Route path="/analytics/users" element={adminPage(<AnalyticsUsers />)} />
        <Route
          path="/analytics/users/:userId"
          element={adminPage(<AdminUserProfile />)}
        />
        <Route
          path="/analytics/referrals"
          element={adminPage(<AnalyticsReferrals />)}
        />
        <Route path="/posts" element={adminPage(<Posts />)} />
        <Route path="/post/:id" element={adminPage(<PostDetail />)} />
        <Route path="/users" element={adminPage(<UsersList />)} />
        <Route
          path="/reportedusers"
          element={adminPage(<ReportedUsers />)}
        />
        <Route path="/AddSighting" element={userPage(<AddSighting />)} />
        <Route path="/account" element={userPage(<Account />)} />
        <Route path="/reports" element={adminPage(<Reports />)} />
        <Route
          path="/referrals"
          element={adminPage(<Navigate to="/analytics/referrals" replace />)}
        />
        <Route path="/delete" element={isLoading ? <LoadingScreen /> : <DeleteAccount />} />
        <Route
          path="*"
          element={
            <Navigate to={userData ? "/admin" : "/login"} replace />
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
